const API_BASE_URL = 'https://live-vastu-backend.onrender.com/api'; 
const SITE_KEY = '411998a29f2746b7737bccff0ee517bf'

let premiumQuestions = [];
let allQuestions = [];
let currentQuestionIndex = 0;
let userPlan = null;
let sessionId = null;
let answers = [];
let prevAnswers = [];
const uploadedImages = {};
let propertyType = null;
let purpose = null;
let userDetails = {};
let bedroomLimit;
let toiletLimit;
let bedroomCounting = 0;
let toiletCounting = 0;
let showDetailsForm;
let userDetailsExist= false;

// Main initialization
async function initPremiumQuiz() {
    try {
       
        sessionId = sessionStorage.getItem('vastu_session_id');
        const selectedPlan = sessionStorage.getItem('selected_plan');
        
        
        if (!sessionId || !selectedPlan || selectedPlan == 'bronze') {
            alert('Please complete the free Vastu scan first and take any paid plan.')
            window.location.href = '/pages/vastu-quiz'
           
            return;
        }
        
        // Parse plan data
        userPlan = selectedPlan;
        
        
        const canProceed = await verifyPremiumAccess();
        
        if (!canProceed) {
            return; // Error shown in verifyPremiumAccess
        }

        if(userPlan === "platinum")
        { 
            let  imagesExist=  await checkUserImages()      
            if (!imagesExist) {
                
                window.location.href = "/pages/upload-rajan";
                return;
        }
        }

    //    await userDetailsForm()
      
      await showUserDetailsForm()
       
        
    } catch (error) {
        console.error('Initialization error:', error);
        showError('Unable to load premium questions. Please try again.');
    }
}


// collect user details section code


async function showUserDetailsForm() {
     const response = await fetch(`${API_BASE_URL}/form-type`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                      "x-site-key": SITE_KEY
                }
            });
            const result = await response.json();
            if(result.success && result.formType == 'premium' || (!userDetailsExist && !sessionStorage.getItem('userDetails')))
            {
                document.querySelector('.top-header h1').textContent = "Fill in your personal details to get Vastu Report";
                document.querySelector('#questionText').textContent=''

                   document.querySelector(".vastu-form").style.display = "block";
    const sections = document.querySelectorAll(".section");
let currentStep = 0;


function showSection(index) {
  sections.forEach((sec, i) => {
    sec.classList.toggle("active", i === index);
  });
}

// Error functions
function showUserDetailsError(input, message) {
  const field = input.closest(".field");
  field.querySelector(".error").innerText = message;
  input.classList.add("error-border");
  console.log("input")
}

function clearError(input) {
  const field = input.closest(".field");
  field.querySelector(".error").innerText = "";
  input.classList.remove("error-border");
}

// Validation
function validateSection(step) {
  let valid = true;
  const inputs = sections[step].querySelectorAll("input, select");

  inputs.forEach(input => {
    clearError(input);
    if (input.hasAttribute("required") && !input.value.trim()) {
      showUserDetailsError(input, "Required");
      valid = false;
    }
  });

  // Custom
  if (step === 0) {
    const name = document.querySelector("[name='name']");
    if (name.value.length < 3) {
      showUserDetailsError(name, "Min 3 chars");
      valid = false;
      
    }
  }

  if (step === 1) {
    const area = document.querySelector("[name='area']");
    if (area.value < 100) {
      showUserDetailsError(area, "Min 100 sq ft");
      valid = false;
    }
  }

  if (step === 2) {
    const members = +document.querySelector("[name='members']").value || 0;
    const adults = +document.querySelector("[name='adults']").value || 0;
    const children = +document.querySelector("[name='children']").value || 0;
    const elders = +document.querySelector("[name='elders']").value || 0;

    if (members !== (adults + children + elders)) {
      showUserDetailsError(document.querySelector("[name='members']"), "Mismatch");
      valid = false;
    }
    console.log(adults + children + elders);
    
  }

  return valid;
}

// Buttons
document.querySelectorAll(".next-btn").forEach(btn => {
  btn.onclick = () => {
    if (!validateSection(currentStep)) return;
    currentStep++;
    showSection(currentStep);
  };
});

document.querySelectorAll(".prev-btn").forEach(btn => {
  btn.onclick = () => {
    currentStep--;
    showSection(currentStep);
  };
});

// Submit
document.getElementById("vastuForm").addEventListener("submit",async function(e) {
  e.preventDefault();
  if (!validateSection(currentStep)) return;

  

  const form = this;
  console.log('form ',form);
  
  const formData = new FormData(form);
  console.log('formdata ',formData);
  
  let data = {};

  formData.forEach((value, key) => {
    data[key] = value.trim();
  });

   // Save data
  userDetails = data;
  console.log("user details",userDetails);
  sessionStorage.setItem('userDetails',JSON.stringify(userDetails))
   alert("Your Details have been stored with us. Press ok to proceed.");
   document.querySelector(".vastu-form").style.display = "none";
  await loadPremiumQuestions();
          showQuestion(0);
});
            }
            

           else{
     await loadPremiumQuestions();
          showQuestion(0);
} 

}



async function checkUserImages() {
    try {
        const res = await fetch(`${API_BASE_URL}/user-submissions/check-user-images/${sessionId}`,
            {
                headers: {
                        "x-site-key": SITE_KEY
                }
        });
        const data = await res.json();
        
        

        if (!data.success) {
           
            return false;
        }

        if (data.data.allValid) {
            return true;
        } else {
            return false;
        }

    } catch (error) {
        console.log(error);
        alert("error while checking map images upload or not!");
    }
}


// Verify user has paid for premium plan
async function verifyPremiumAccess() {
    try {
        const response = await fetch(`${API_BASE_URL}/user-submissions/${sessionId}/payment-status`,
            {
                headers: {
                        "x-site-key": SITE_KEY
                }
            }
        );
        
        if (!response.ok) {
            throw new Error('Failed to check payment status');
        }
        
        const result = await response.json();
        
        if (!result.success) {
            showError(result.message);
            return false;
        }
        
        const userData = result.data;

        if(userData.userId)
        {
            const detailsRes = await fetch(`${API_BASE_URL}/user-details/${userData.userId}`,
            {
                headers: {
                        "x-site-key": SITE_KEY
                }
            }
        );
        let detailsData= await detailsRes.json()
        if(detailsData.success && detailsData.data)
        {
            userDetailsExist = true;
        }
        }

        

        if (userData.vastu_task) {
                message = 'Please renew your plan to access this feature.';
                 showPaymentRequired(message);
            return false;
            }
        
        // Check if user can proceed
        if (userData.can_proceed && userData.plan_type !== 'bronze') {
            // Update UI with plan info
            prevAnswers = userData.answers
            document.querySelector('.top-header h1').textContent = 
                `Complete Your ${userPlan.slice(0,1).toUpperCase()+userPlan.slice(1).replace("_"," ")} Vastu Analysis`;
            return true;
        } else {
            // User hasn't paid or has basic plan
            let message = 'Please complete your payment to access premium questions.';
            
            if (userData.payment_status === 'pending') {
                message = 'Your payment is still pending. Please wait for confirmation.';
            } else if (userData.plan_type === 'bronze') {
                message = 'Please upgrade to a premium plan to access this feature.';
            }
            
            showPaymentRequired(message);
            return false;
        }
        
    } catch (error) {
        console.error('Verification error:', error);
        showError('Unable to verify your premium access.');
        return false;
    }
}

async function loadPremiumQuestions() {
    try {
        // Load ALL questions
        const response = await fetch(`${API_BASE_URL}/questions`,
            {
                headers: {
                        "x-site-key": SITE_KEY
                }
            }
        );
        
        if (!response.ok) throw new Error('Failed to load questions');
        
        const result = await response.json();
        if (!result.success) throw new Error(result.message);
        
        // Simple filter: match question_plan with user's plan
     if(Array.isArray(prevAnswers) && prevAnswers.length === 0)
     {
             propertyType = sessionStorage.getItem('vastu_property_type');
         purpose = sessionStorage.getItem('vastu_purpose');

        if(!propertyType){
            sessionStorage.setItem('question','premium')
             window.location.href = '/pages/select-property';
             return;
             
        }
        else if(!purpose)
        {
            sessionStorage.setItem('question','premium')
            window.location.href = '/pages/purpose';
            return;
            
        }
        sessionStorage.removeItem('question')

         premiumQuestions = result.data.filter(question => 
            question.question_plan === 'bronze' || question.question_plan === 'silver'
        );
     }else{
          premiumQuestions = result.data.filter(question => 
            question.question_plan === 'silver' 
        );
     }
           

           if(userPlan === 'gold')
        {
            result.data.forEach((question)=>{
                if(question.question_plan === 'gold')  premiumQuestions.push(question)
            })
        }

             if(userPlan === 'platinum')
        {
            result.data.forEach((question)=>{
                if(question.question_plan !== 'bronze' && question.question_plan !== 'silver')  premiumQuestions.push(question)
            })
        }
        
       allQuestions = premiumQuestions;
        
        if (premiumQuestions.length === 0) {
            throw new Error(`No questions found for ${userPlan} plan`);
        }
        
    } catch (error) {
        console.error('Error loading questions:', error);
        throw error;
    }
}

// condition according to input by user on bedroom and toilet

function shouldShowQuestion(question) {

    if (question.parent_key) {

        // bedroom case
        if (question.parent_key === 'bedroomCounting') {
            if (!bedroomLimit) return false;

            if (bedroomLimit == 1) {
                return question.sub_order == 0;
            }

            return question.sub_order > 0 && question.sub_order <= bedroomLimit;
        }

        // toilet case
        if (question.parent_key === 'toiletCounting') {
            if (!toiletLimit) return false;

            if (toiletLimit == 1) {
                return question.sub_order == 0;
            }

            return question.sub_order > 0 && question.sub_order <= toiletLimit;
        }
    }

    return true;
}



// Show question (following your pattern)
function showQuestion(index) {
   
    
    //     while (
    //     index < premiumQuestions.length &&
    //     !shouldShowQuestion(premiumQuestions[index])
    // ) {
    //     index++;
    // }

     if (index < 0 || index >= premiumQuestions.length) return;
   
    document.querySelector('.top-header h1').textContent = 
                `Complete Your ${userPlan.slice(0,1).toUpperCase()+userPlan.slice(1).replace("_"," ")} Vastu Analysis`;

                document.querySelector(".quiz-navigation").style.display = "block";

    currentQuestionIndex = index;
    const question = premiumQuestions[index];
   console.log('limit bed: ',bedroomLimit, ' counting bed: ',bedroomCounting);
   console.log('limit toilet: ',toiletLimit, ' counting toilet: ',toiletCounting);
   
    

    // Update progress
    document.getElementById('progressText').textContent = 
        `${currentQuestionIndex + 1}/${premiumQuestions.length}`;
    
    // Display question
    document.getElementById('questionText').textContent = question.question_text;
    
    // Display options
    const optionsContainer = document.getElementById('optionsContainer');
    optionsContainer.innerHTML = '';
    
    if (question.question_type === 'multiple_choice' && question.options && question.options.length > 0) {

         const existingAnswer = answers.find(
            answer => answer.question_id === question._id
        );

      

        question.options.forEach((option, optionIndex) => {
            const uniqueId = `premium_q${currentQuestionIndex}_opt${optionIndex}`;
            
            const label = document.createElement('label');
            label.className = 'option-item';
            label.htmlFor = uniqueId;
            
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'premium_direction';
            input.value = option;
            input.id = uniqueId;
            input.onclick = (e) => 
            {
                e.preventDefault();
                selectOption(option, label);
            }
                

            if (existingAnswer && existingAnswer.answer === option) {
                input.checked = true;
                label.classList.add('selected');
            }
            
            const span = document.createElement('span');
            span.textContent = option;
            
            label.appendChild(input);
            label.appendChild(span);
            optionsContainer.appendChild(label);
        });
    }

    
    // Show prev button
    document.getElementById('prevBtn').style.display = index > 0 ? 'block' : 'none';
}

let isProcessing = false;

function getFilteredQuestions() {
    return allQuestions.filter(q => {

        if (q.parent_key === 'bedroomCounting' && bedroomLimit) {
            

            if (bedroomLimit == 1) return q.sub_order == 0;

            return q.sub_order > 0 && q.sub_order <= bedroomLimit;
        }

        if (q.parent_key === 'toiletCounting' && toiletLimit) {
           

            if (toiletLimit == 1) return q.sub_order == 0;

            return q.sub_order > 0 && q.sub_order <= toiletLimit;
        }

        return true;
    });
}

// Handle option selection (same pattern)
function selectOption(option, labelElement) {

    if(isProcessing) return;

    isProcessing = true;
     
    // Remove selected class from all options
    document.querySelectorAll('.option-item').forEach(item => {
        item.classList.remove('selected');
    });
    
    // Add selected class to clicked option
    labelElement.classList.add('selected');

     const currentQuestion = premiumQuestions[currentQuestionIndex];

      // Store answer with question data
    const answerData = {
        question_id: currentQuestion._id,
        question_text: currentQuestion.question_text,
        question_key: currentQuestion.question_key || "",
        sub_order: currentQuestion.sub_order || "",
        answer: option,
        timestamp: new Date().toISOString()
    };

      if(currentQuestion.question_key == 'bedroomCounting')
        {
            bedroomLimit = option
            answers = answers.filter(a => a.question_key !== 'bedroomFacing');
            premiumQuestions = getFilteredQuestions();
        }

        if(currentQuestion.question_key == 'toiletCounting')
        {
            toiletLimit = option
             answers = answers.filter(a => a.question_key !== 'toiletFacing');
            premiumQuestions = getFilteredQuestions();
        }
    
    // Check if we already have an answer for this question
    const existingAnswerIndex = answers.findIndex(
        answer => answer.question_id === currentQuestion._id
    );
    
    if (existingAnswerIndex !== -1) {
        // Update existing answer
        answers[existingAnswerIndex] = answerData;
    } else {
        // Add new answer
        answers.push(answerData);
    }
    
    console.log(answers);
    
   
    
    // Auto-advance after delay (your pattern)
    setTimeout(() => {
        isProcessing = false;
        if (currentQuestionIndex < premiumQuestions.length - 1) {
            showQuestion(currentQuestionIndex + 1);
        } else {
            // All premium questions completed
            saveDataAndCallOpenAI();
        }
    }, 500);
}

async function handleImageUpload(questionIndex, inputElement) {
    const files = Array.from(inputElement.files);
    const currentQuestion = premiumQuestions[currentQuestionIndex];
    const previewContainer = document.getElementById(`preview${questionIndex}`);
    
    if (files.length === 0) return;
    
    // Clear previous previews
    previewContainer.innerHTML = '';
    
    // Show loading in preview
    previewContainer.innerHTML = '<p>Uploading images...</p>';
    
    try {
        
        // Upload each image to Cloudinary
        const uploadPromises = files.map(async (file) => {
            const formData = new FormData();
            formData.append('images', file);
            
            const response = await fetch(
                `${API_BASE_URL}/upload-image/${sessionId}/${currentQuestion._id}`,
                
                    
                    {
                    method: 'POST',
                    headers: {
                        "x-site-key": SITE_KEY
                    },
                    body: formData
                }
            );
            
            const result = await response.json();
            
            if (result.success) {
               
                
                return {
                    url: result.data.url,
                    public_id: result.data.public_id,
                    originalName: file.name
                };
            } else {
                throw new Error(result.message);
            }
        });
        
        // Wait for all uploads to complete
        const uploadedResults = await Promise.all(uploadPromises);
        
        // Clear loading and show previews
        previewContainer.innerHTML = '';
        
        // Store uploaded images
        uploadedImages[questionIndex] = uploadedResults;
        
        // Create previews with Cloudinary URLs
        uploadedResults.forEach((result, index) => {
            const preview = document.createElement('div');
            preview.className = 'image-preview-item';
            preview.innerHTML = `
                <img src="${result.url}" class="image-preview" alt="Preview ${index + 1}">
                <div class="image-info">✅ ${result.originalName}</div>
            `;
            previewContainer.appendChild(preview);
        });
        
        // Save answer with image URLs
        const answerData = {
            question_id: currentQuestion._id,
            question_text: currentQuestion.question_text,
            answer: 'images_uploaded',
            images: uploadedResults,
            timestamp: new Date().toISOString()
        };
        
        // Save to backend
        await saveAnswer(answerData);

    
   // Auto-advance after delay (your pattern)
    setTimeout(() => {
        if (currentQuestionIndex < premiumQuestions.length - 1) {
            showQuestion(currentQuestionIndex + 1);
        } else {
            // All premium questions completed
            // saveDataAndCallOpenAI();
        }
    }, 10000);
}
catch (error) {
        console.error('Upload error:', error);
        previewContainer.innerHTML = `
            <div style="color: red; padding: 10px; background: #ffe6e6;">
                ❌ Error uploading images. Please try again.
            </div>
        `;
    }
}

async function saveAnswer(answerData) {
    const sessionId = sessionStorage.getItem('vastu_session_id');
    
    const response = await fetch(`${API_BASE_URL}/user-submissions/${sessionId}/add-answers`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "x-site-key": SITE_KEY          
        },
        
        body: JSON.stringify({
            answers: [answerData],
            propertyType,
            purpose
        })
    });
    
    const result = await response.json();
    return result.success;
}


function showFinalMsg(){
    const loadingData= `<div class="report-container">
            <h2>Expert Review in Progress</h2>
                <p>Dr. Puneet Chawla, a renowned Vastu expert, will personally review all the information you have shared, including your answers, layouts, and maps.</p>
                <p class="processing-note">After a thorough analysis, we will get back to you with detailed insights within 3–4 working days.</p>
                <p class="processing-note">Please keep eye on your email inbox.</p>
                
                </div>`;
             document.querySelector('.question-wrapper').innerHTML = loadingData;
}



// call open api

async function saveDataAndCallOpenAI() {
    try {
        console.log('updating user data to database');
        // document.getElementById('mobileVerification').style.display = 'none';
        // document.getElementById('questionContainer').style.display = 'block';
        showFinalMsg();
        sessionStorage.setItem('processPremium',true)

        const response = await fetch(`${API_BASE_URL}/user-submissions/${sessionId}/add-answers`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "x-site-key": SITE_KEY  
            },
            body: JSON.stringify(
                {
                answers,
                userDetails: JSON.parse(sessionStorage.getItem('userDetails'))
            }
            )
        });

        const result = await response.json();
        
        if (result.success) {
            
        //   showCompletionScreen()
        //    showAIReport(result.data)
        } else {
            alert('Error saving your data. Please try again.');
        }
    } catch (error) {
        console.error('Error saving user data:', error);
        alert('Error saving your data. Please try again.');
    }
}

// Previous question
function prevQuestion() {
    if (currentQuestionIndex > 0) {
        showQuestion(currentQuestionIndex - 1);
    }
}



// UI Helper functions
function showError(message) {
    document.getElementById('questionText').textContent = message;
    document.getElementById('optionsContainer').innerHTML = 
        `<a href="/" class="btn">Return to Home</a>`;
}

function showPaymentRequired(message) {
    document.getElementById('questionText').textContent = message;
    document.getElementById('optionsContainer').innerHTML = `
        <div style="text-align: center;">
            <a href="/pages/all-plan" class="btn btn-primary">View Premium Plans</a>
            <a href="/" class="btn">Return to Home</a>
        </div>
    `;
}

function showCompletionScreen() {
   
    document.querySelector('.question-wrapper').innerHTML = `
        <div style="text-align: center;">
             <strong>We've successfully collected all your details.</strong><br>
    Our Vastu experts are now analyzing your property and will get back to you 
    with a comprehensive report within 2-3 days.
            
        </div>
    `;
}

function redirectToHome(message) {
    alert(message);
    window.location.href = '/';
}



// Initialize when page loads

document.addEventListener('DOMContentLoaded', function() {
    if(sessionStorage.getItem('processPremium'))
    {
        showFinalMsg()
        return;
    }
  initPremiumQuiz();
  // Navigation button event
document.getElementById('prevBtn').addEventListener('click', prevQuestion);
});